import { useTokens } from "@gemini/core";
import { useMediaQuery } from "./useMediaQuery";
import { useEffect, useState } from "react";
/**
 * The viewport is evaluated on CSR using a "min-width: **1024px**" query.
 * Returns **true** by default during SSR.
 *
 * ### Usages
 *
 * ```tsx
 * const isDesktop = useIsDesktop()
 *
 * ```
 *
 * ### SSR value
 * Best practice is to always mount components during SSR, regardless of the viewport
 * To that intent, useIsDesktop hook always returns true during SSR
 */
export const useIsDesktop = () => {
    const tokens = useTokens();
    const lg = tokens["breakpoint.lg"] || 1024;
    return useMediaQuery(`(min-width: ${lg}px)`);
};
export function useIsDesktopCSR() {
    const [isDesktop, setIsDesktop] = useState(undefined);
    const tokens = useTokens();
    useEffect(() => {
        const lg = tokens["breakpoint.lg"] || 1024;
        // This function detects and sets the device type
        const updateIsDesktop = () => {
            setIsDesktop(window.innerWidth >= lg);
        };
        // First detection after mount
        updateIsDesktop();
        // Listen to resize events to update dynamically
        window.addEventListener("resize", updateIsDesktop);
        return () => {
            window.removeEventListener("resize", updateIsDesktop);
        };
    }, [tokens]);
    return isDesktop;
}
